var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-recommendations"},[_c('BCXContentArea',{attrs:{"no-padding":""}},[_c('BCXBreadcrumbs',{attrs:{"items":_vm.breadcrumbItems}}),_c('RecommendationsForMe')],1),_c('MyRecommendations')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }